import React, {forwardRef} from "react";
import {ATag} from "@cisco-sbg-ui/magna-react";
import css from "./Avatar.module.scss";

const Avatar = forwardRef(({children, ...rest}, ref) => {
  return (
    <ATag ref={ref} className={css.avatar} {...rest}>
      {children}
    </ATag>
  );
});

export default Avatar;
